import React from "react";
import { FaArrowRight } from "react-icons/fa";
import { motion } from "framer-motion";

export default function CustomAction({ text, action, mainColor, disabled }) {
  return (
    <motion.button
      className="custom-action"
      onClick={action}
      style={{ backgroundColor: mainColor }}
      whileHover="hover"
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{
        ease: "easeOut",
        duration: 0.35,
        delay: 0.2,
      }}
      disabled={disabled}
    >
      <motion.p
        variants={{
          hover: {
            scale: 1.2,
            fontWeight: "bold",
            textDecoration: "underline",
          },
        }}
        transition={{ type: "spring", stiffness: 200 }}
      >
        {text}
      </motion.p>
      <motion.div
        variants={{
          hover: { x: 2 },
        }}
        transition={{ type: "spring", stiffness: 200 }}
      >
        <FaArrowRight />
      </motion.div>
    </motion.button>
  );
}
